import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { z } from 'zod'
import { SistemaTipo } from "../../../../../types/enum/enum"
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme"
import {
    OperacionAFOPUTablaValorUpdate,
    OperacionAFOPUTablaValorVista,
    OperacionAFOPUInsert,
    schemaOperacionAFOPUTablaValorUpdate,
    schemaOperacionAFOPUTablaValorVista,
    schemaOperacionAFOPUInsert,
    OperacionAFOPUTablaValorVistaInicial,
    schemaOperacionAFOPUTablaValorVistaInicial,
    FormUpdateAFOPUTablaValores,
    OperacionAFOPUTablaValorHistoricoGrupo,
    schemaOperacionAFOPUTablaValorHistoricoGrupo
} from '../types/dto'
import { OperacionAFOPU, schemaOperacionAFOPU } from '../types/types'

export const getEndpoint = (url = '') => `operaciones/afopu${url}`

export const HttpAFOPU = {
    get: (idOperacion: number): Promise<OperacionAFOPU> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionAFOPU.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionAFOPUInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionAFOPUInsert.safeParse(operacion)
        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getTablaValoresInicial: (codPais: number): Promise<OperacionAFOPUTablaValorVistaInicial[]> => {
        const url = getEndpoint(`/0/tabla-valores/inicial/${codPais}`);
        const schemaResponse = z.array(schemaOperacionAFOPUTablaValorVistaInicial);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValoresInicial:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    getTablaValores: (idOperacion: number): Promise<OperacionAFOPUTablaValorVista[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores`);
        const schemaResponse = z.array(schemaOperacionAFOPUTablaValorVista);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValores:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateValor: (idOperacion: number, idCodTablaValor: number, valorUpdate: OperacionAFOPUTablaValorUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionAFOPUTablaValorUpdate.safeParse(valorUpdate);
        if (!parsed.success) {
            console.error('Error de validación de entrada en updateValor:', parsed.error.issues);

            return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/tabla-valores/valores/${idCodTablaValor}`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateValor:', error);

                return Promise.reject('Error de red.');
            });
    },

    getTablaValoresHistorico: (idOperacion: number): Promise<OperacionAFOPUTablaValorHistoricoGrupo[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores/historico`);
        const schemaResponse = z.array(schemaOperacionAFOPUTablaValorHistoricoGrupo);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValoresHistorico:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    

    updateTablaValores: (idOperacion: number, datos: FormUpdateAFOPUTablaValores): Promise<BaseResponse> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores`);
        
return HttpAxiosRequest.put(url, datos);
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.AFOPU),

} as const